import { render, staticRenderFns } from "./news-add-or-update.vue?vue&type=template&id=663ee66d&scoped=true&"
import script from "./news-add-or-update.vue?vue&type=script&lang=js&"
export * from "./news-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./news-add-or-update.vue?vue&type=style&index=0&id=663ee66d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ee66d",
  null
  
)

export default component.exports